import {Component, Input, OnInit} from "@angular/core";
import {MatRipple} from "@angular/material/core";
import {MatTooltip} from "@angular/material/tooltip";
import {CommonModule} from "@angular/common";
import {FormControl} from "@angular/forms";
import {ButtonEventService} from "../../new-information/services/button-event.service";

@Component({
  selector: 'app-add-flats',
  template: `
    <button class="btn btn-light"
            mat-ripple
            [matTooltip]="tooltipMessage"
            matTooltipPosition="above"
            [class.disabled]="control?.invalid || floors <= 0"
            (click)="control?.valid && floors > 0 ? addFlats() : null"
    >
      <ng-container *ngIf="!addFlatLoading">Квартиры</ng-container>
      <ng-container *ngIf="addFlatLoading">
        <div class="loading"></div>
      </ng-container>
    </button>
  `,
  standalone: true,
  imports: [
    CommonModule,
    MatRipple,
    MatTooltip,
  ],
    styles: [
    `
      .btn {
        margin-top: 5px;
      }

    `
  ],
})

export class AddFlatLoading implements OnInit {
  @Input() control: FormControl | any;
  addFlatLoading = false;

  constructor(private btnService: ButtonEventService) {
  }

  ngOnInit() {
    this.btnService.buildingUpdated$.subscribe(_ => this.addFlatLoading = false);
  }

  get tooltipMessage(): string {
    if (!this.control) return '';

    if (this.control.invalid) {
      return this.floors ? 'Заполните все обязательные поля в пятне!'
        : 'Заполните все обязательные поля и кол-во этажей в пятне!';
    }

    if (this.floors <= 0) {
      return 'Заполните кол-во этажей в пятне!';
    }

    return '';
  }


  get floors() {
    return this.control?.get('floors')?.value;
  }

  addFlats() {
    this.addFlatLoading = true;
    this.btnService.emitButtonClick(true);
  }
}
